module.exports = __webpack_public_path__ + "pdk16-32.jpg?0f8357f9f4bdf886850e0f25b6349e78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/pdk16-32.jpg
// module id = 78
// module chunks = 0